export default {
  title: 'Your communication preferences have been updated.',
};
